<div class="wrap uk-margin-top">
    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loading === false">
        <div class="uk-form-stacked uk-margin-large uk-grid-medium" uk-grid>
            <div class="uk-width-12-12 uk-position-relative uk-margin-top">
                <div class="main-title bold">{{ company.Name }}</div>
                <div class="uk-float-right">
                    <button class="back-button button-main-title regular" type="submit" (click)="updateCompany()"
                        style="padding-right: 20px;"
                        [attr.uk-tooltip]="formChanged === false ? 'Aucun changement à valider' : null"
                        [disabled]="formChanged === false">
                        <span class="uk-text-uppercase">Valider les changements</span>
                        <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="back">
                    </button>
                </div>
            </div>
            <div uk-grid class="uk-width-12-12 padding-20 uk-margin-top vop-background-white remove-grid-ml-pl"
                style="padding-bottom: inherit;">
                <div class="uk-width-4-12" style="min-height: 316.66px;">
                    <div class="img-wrap">
                        <img src="../../../../assets/img/undefined.png"
                            onerror="this.src='../../../../assets/icons/Adherent.svg';this.className='img-error';">
                    </div>
                </div>
                <div class="uk-width-8-12 uk-grid-small" uk-grid>
                    <div class="uk-width-2-3">
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Nom</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                    [(ngModel)]="company.Name">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3">
                        <div class="uk-margin">
                            <label class="label">Téléphone</label>
                            <div class="uk-form-controls">
                                <input class="input alt color-cold-grey bold" type="text" [(ngModel)]="company.Mobile">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="title bold uk-margin-small-bottom">
                    Documents
                    <img href="#edit-user-documents" uk-toggle src="../../../assets/icons/Edit.svg" width="24px"
                        height="24px" alt="back" class="pointer">
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-3">
                        <div class="uk-margin">
                            <label class="label">Extrait K-BIS</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button [attr.disabled]="kbisMissing ? '' : null"
                                    class="button bold uk-display-inline-block" (click)="getKBIS()">
                                    <span>K-BIS</span>
                                    <i class="material-icons uk-margin-left">add</i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3">
                        <div class="uk-margin">
                            <label class="label">Certificat d'immatriculation SIREN</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button [attr.disabled]="sirenMissing ? '' : null"
                                    class="button bold uk-display-inline-block" (click)="getSIREN()">
                                    <span>SIREN</span>
                                    <i class="material-icons uk-margin-left">add</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold uk-margin-small-bottom">
                    Données de facturation
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-3">
                        <div class="uk-margin">
                            <label class="label">Numéro de carte</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <span class="color-cold-grey bold uk-width-1-1">{{ creditCard }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold">
                    Membres de l'équipe de {{ company.Name }}
                </div>

                <div class="uk-margin-small-top" *ngIf="noMemberResult === true">
                    <span>Aucun membre dans l'équipe de {{ company.Name }}</span>
                </div>

                <div *ngIf="loadingMember === true">
                    <div uk-spinner class="uk-text-center uk-width-1-1"></div>
                </div>

                <div class="uk-margin-medium-top" *ngIf="loadingMember === false && noMemberResult === false">
                    <div uk-grid *ngFor="let member of members; let i = index"
                        class="uk-width-1-1 item-list dark remove-grid-ml-pl">
                        <div class="uk-width-1-12 item-column">
                            <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/User.svg"
                                width="64px" height="64px" alt="user" />
                        </div>
                        <div class="uk-width-3-12 item-column pointer"
                            [routerLink]="['/user/informations', member.AccountId]">
                            <span>{{ member.FirstName }} {{ member.LastName }}</span>
                        </div>
                        <div class="uk-width-expand item-column">
                            <div class="uk-text-center">
                                <button disabled
                                    class="uk-button round-button bigger uk-display-inline-block">Admin</button>
                                <button disabled
                                    class="uk-button round-button bigger uk-display-inline-block uk-margin-small-left">Tarif
                                    pro</button>
                                <button
                                    class="uk-button round-button bigger round-button-toggle uk-display-inline-block uk-margin-small-left">Staff</button>
                            </div>
                        </div>
                        <div class="uk-width-1-12 item-column">
                            <img (click)="deleteCompanyMember(member)" class="uk-position-absolute pointer"
                                style="right: 20px; filter: brightness(200%);" src="../../../assets/icons/delete.svg"
                                width="32px" height="32px" alt="delete" />
                        </div>
                    </div>
                </div>
                <div>
                    <button class="button bold uk-float-right add-user uk-margin-medium-top" href="#find-user"
                        uk-toggle>
                        <span>Ajouter un membre</span>
                        <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back"
                            class="uk-margin-left">
                    </button>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px; padding-bottom: 0px;">
            </div>
        </div>
    </div>
</div>

<app-find-user (changed)="addSocietyMember($event)"></app-find-user>